







































































































import { IQuoteFreightEstimates } from '@/models';
import Vue, { PropType } from 'vue';
export default Vue.extend({
  name: 'QuoteFreightSectionEstimatesDisplay',
  props: {
    estimates: {
      type: Object as PropType<IQuoteFreightEstimates>
    }
  }
});
